import styled from 'styled-components';
export const DownloadAppModalStyled = styled.div`
  .countryCodeInputWrapper {
    direction: ltr;
  }
  .closeBtn {
    position: absolute;
    top: 6px;
    right: 12px;
    cursor: pointer;
    z-index: 2;
  }
  .title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 19px;
    color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['900']};
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 32px;
    color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['400']};
  }
  .submitCTA {
    color: ${(props) => props.theme.color.white} !important;
    background: ${(props) => props.theme.colors.primary.green['700']} !important;
    &:disabled {
      color: ${(props) => props.theme.color.white} !important;
      background: ${(props) => props.theme.colors.primary.green['700']} !important;
      opacity: 30%;
    }
  }
  .app-icon-wrapper {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 28px;
  }
  .hand-mobile-img-wrapper {
    position: absolute;
    top: 33px;
    right: 0;
  }

  @media (max-width: 850px) {
    .hand-mobile-img-wrapper {
      bottom: 8px;
      img {
        margin-right: -16px !important;
        width: 85%;
      }
    }
  }
  
  &.rtl {
    .closeBtn {
      right: auto;
      left: 12px;
    }
    .countryCodeInputWrapper {
      .country-div {
        width: 100%;
        & > div {
          flex: auto;
          &.dropdown-border {
            flex: none;
          }
        }
      }
      .form-floating {
        & > label {
          text-align: right;
          width: 100%;
        }
        .form-control:focus ~ label,
        .form-control:not(:placeholder-shown) ~ label {
          display: none;
        }
        .country-dropdown-textbox {
          direction: rtl;
        }
      }
      .invalid-error {
        direction: rtl;
      }
    }
    .hand-mobile-img-wrapper {
      left: 0;
      right: auto;
    }
  }
`;
